module.exports = __webpack_public_path__ + "n.no2.214c8c7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/n.no2.jpg
// module id = 9sAp
// module chunks = 0